<template>
  <div id="rewards">
    <header-o :model="headerData"></header-o>
    <div class="margin-vertical-10" :style="[isGamification ? {'margin-top': '-70px'} : (showActionButton ? {'margin-top': '-84px'} : {'margin-top': '-140px'})]">
      <div v-if="refer_code != null" class="scratch-card-container bg-light radius-5 padding-0510 box-shadow margin-bottom-10">
        <div class="align-hor center-ver flex-09 space-between">
          <div class="align-hor center-ver flex-09">
            <div class="radius50 align-hor center-ver center-hor opc-80 margin-right-10" style="width: 35px; height: 35px;" :style="{backgroundColor: bgTheme}">
              <img class="smaller-icon" src="@/assets/share.svg">
            </div>
            <div class="text-left">
              <div class="text-medium font-bold">{{refer_code}}</div>
              <div class="text-small">Your referral code</div>
            </div>
          </div>
          <div @click="getShareMsg(null, 'wa')" class="text-regular pointer" :style="{color: bgTheme}">Share</div>
        </div>
      </div>

      <div id="copied-toast" class="font-bold pos-fixed pos-center-hor pull-down" style="width: 100px; padding: 5px; border-radius: 10px; background: rgba(0, 0, 0, 0.3); margin-bottom: 70px; color: white; display: none;">
        Link Copied
      </div>

      <div class="scratch-card-container bg-light radius-5 padding-151 box-shadow margin-bottom-10" style="min-height: 240px;" v-if="allUserOffers.length || showShimmer">
        <div class="sc-wrapper" v-if="allUserOffers.length">
          <div class="scratch-card sc-wrap pos-rel margin-bottom-15 radius-10" :style="[uo.is_scratched ? '' : {'background': bgTheme}]" v-for="(uo, i) in allUserOffers" style="margin: 0 5px 10px">
            <div @click="showScratchCard(uo)"
                 :style="!uo.is_scratched ? 'height:85%': windowWidth < 511?'height:100%;min-height:170px' : 'height: 100%;min-height:140px'" >
              <div v-if="!uo.is_scratched" >
                <img class="full-width opc-25" src="@/assets/sc-bg.svg">
                <div class="radius50 pos-abs pos-center-ver pos-center-hor align-hor center-ver center-hor" style="height: 60px; width: 60px;" :style="{background: darkerBg}">
                  <img class="w25 opc-80" src="@/assets/medal-white.svg">
                </div>
              </div>
              <div class="bg-lighter-grey radius-10 pointer" v-else
                   style="display: flex; height:100%;
                          flex-direction: column; align-items: center; justify-content: center">
                <div>
                  <img class="w25 opc-80 margin-bottom-10" src="@/assets/reward.svg">
                </div>
                <div>{{formatReward(uo.reward_type, uo.value, true)}}</div>
              </div>
            </div>
            <transition name="fade">
              <div class="overlay" v-if="uo.show_sc">
                <div class="text-light" style="height: 100vh;">
                  <div style="display: flex; justify-content: end; width: 100%">
                    <img src="@/assets/close.svg" class="w10 pointer" v-on:click="hideScratchCard(uo)" style="padding:10px">
                  </div>
                  <div class="align-ver center-ver center-hor" style="height: 90%;">
                    <div class="offer-desc margin-bottom-20">{{uo.earned_for}}</div>
                    <scratch-card :key="renderCount"
                                  :cardWidth="cardWidth"
                                  :cardHeight="cardHeight"
                                  :finishPercent="finishPercent"
                                  :imageBg="bgTheme"
                                  :imageUrl="imageUrl"
                                  :imageDarkBg="darkerBg"
                                  :brushUrl="scBgUrl"
                                  :forceReveal="forceReveal"
                                  @complete="onComplete(uo)"
                                  v-if="!uo.is_scratched">
                      <div class="">
                        <img class="w25 opc-80" src="@/assets/reward.svg">
                      </div>
                      <div>
                        <div class="text-center text-grey text-extra-large font-bold" v-if="uo.value > 0">{{formatReward(uo.reward_type, uo.value, true)}}</div>
                        <div class="text-center text-grey text-extra-large font-bold" v-else>Better luck next time</div>
                      </div>
                    </scratch-card>
                    <div v-else>
                      <div class="card-content bg-light radius-30">
                        <div class="margin-bottom-20">
                          <img class="scratched-reward-icon" src="@/assets/reward.svg" alt="cash-reward">
                        </div>
                        <div class="text-center text-grey text-extra-large font-bold" v-if="uo.value > 0">{{formatReward(uo.reward_type, uo.value, true)}}</div>
                        <div class="text-center text-grey text-large" v-else>Better luck next time</div>
                      </div>
                    </div>
                    <div class="offer-details text-center margin-horizontal-30">
                      <div class="margin-bottom-5">Ref Number: #{{uo.ref}}</div>
                      <div v-if="uo.scratched_on">Earned on: {{formattedDate(uo.scratched_on, true)}}</div>
                    </div>

                  </div>
                </div>
              </div>
            </transition>
          </div>
        </div>

         <div @click="redirectTo('offers')" v-if="allUserOffers.length && show_see_offer">
          <button class="custom-button small padding-horizontal-10 text-light radius-5 pointer" :style="{background: bgTheme}">See Offers</button>
        </div>

        <div class="margin-bottom-20" v-if="allUserOffers.length === 0 && showShimmer">
          <div class="align-hor space-between margin-bottom-20 padding-vertical-10" v-for="$i in 1">
            <div class="wrapper" :class="$j < 2 ? 'margin-right-20' : ''" v-for="$j in 2">
              <div style="min-height:90px"
                class="comment shimmer-box animate bg-light-grey" v-for="$k in 2"></div>
            </div>
          </div>
        </div>
      </div>

      <div class="bg-light bottom-radius-5 padding-20 margin-bottom-10 pos-rel box-shadow align-ver center-hor center-ver" style="min-height: 70vh" v-if="allUserOffers.length == 0 && !showShimmer">
        <img class="extra-large-icon margin-bottom-20" src="@/assets/no-data.svg">
        <div class="margin-bottom-20">You haven't Earned any Rewards yet!</div>
        <!-- <div @click="redirectTo('offers')" v-if="show_see_offer">
          <button class="custom-button small padding-1020 text-light radius-5 pointer" :style="{background: bgTheme}">See offers</button>
        </div> -->
      </div>
      <infinite-loading @infinite="infiniteHandler" ref="infiniteLoading"><span slot="no-more"></span></infinite-loading>
    </div>
  </div>
</template>
<script>
  import { globals } from "@/mixins/globals"
  import axios from "axios"
  import OverlapHeader from '@/components/overlapped-header'
  import ScratchCard from '@/components/scratch-card'
  import BRUSH from '@/assets/brush.png';
  import SCBG from '@/assets/sc-bg-empty-circle.svg';
  import SCBG1 from '@/assets/sc-bg.svg';
  export default {
    mixins: [globals],
    components: {
      'header-o': OverlapHeader,
      'scratch-card': ScratchCard
    },
    data() {
      return {
        headerData: {
          onlyHeader: false,
          rewards: true,
          referrals: false
        },
        page: 1,
        allUserOffers: [],
        windowWidth : window.screen.width,
        renderCount: 0,
        cardWidth: 200,
        cardHeight: 200,
        finishPercent: 40,
        brushUrl: BRUSH,
        scBgUrl: SCBG,
        imageUrl : SCBG1,
        forceReveal: false,
        placeholder: true,
        is_shimmer: true,
        refer_code: null,
        show_see_offer: false
      }
    },
    beforeMount() {
      var self = this;
      if (window.addEventListener) {
              window.addEventListener("flyyDataSet", self.refreshRewards, false);
      } else {
              window.attachEvent("onflyyDataSet", self.refreshRewards);
      }

      this.loadDataFromCookie();
      this.$store.state.user.show_currency_name = this.rewardsShowCurrencyName;
      this.$store.state.user.show_currency_list = this.rewardsShowCurrencyList;
      this.$store.state.user.show_action_button = this.showActionButtonInRewards;
    },
    computed: {
      showPlaceHolder: function() {
        return this.placeholder;
      },
      showShimmer: function() {
        return this.is_shimmer;
      }
    },
    methods: {
      refreshRewards() {
        this.$refs.infiniteLoading.$emit('$InfiniteLoading:reset');
      },
      onComplete(uo) {
        console.log(uo);
        var ref = uo.ref;
        var self = this;
        var url = this.$store.getters.flyyDomain+'/scratch_user_offer/' + ref;
        var headers = this.$store.getters.headers;

        var options = {
          headers: headers
        }

        axios.put(url, {
          mode: 'no-cors',
        }, options).then((resp) => {
          if(resp.status == 200) {
            var data = resp.data;
            var user_offer = data.user_offer;
            uo.is_scratched = user_offer.is_scratched;
            self.getBasicAppInfo();
          } else {
            console.log("Error fetching the user offers");
          }
        }).catch((error) => {
          console.log("Catch block");
        });
      },
      showScratchCard(uo) {
        uo.show_sc = true;
      },
      hideScratchCard(uo) {
        uo.show_sc = false;
      },
      infiniteHandler($state) {
        var self = this;
        var url = self.$store.getters.flyyDomain + '/web_user_offers';//'/v4/user_offers';
        var headers = self.$store.getters.headers;
        axios.get(url, {
          headers: headers,
          params: {
            page: self.page,
          }
        }).then((resp) => {
          if(resp.status == 200) {
            var data = resp.data;
            var user_offers = data.user_offers;
            if (self.page == 1) {
              self.refer_code = data.refer_code;
              self.show_see_offer = data.show_see_offer;
            }
            if(user_offers && user_offers.length) {
              self.page += 1;
              var tempArr = [];
              user_offers.forEach((uo) => {
                if (!uo.locked && (uo.reward_type != "Vouchers")) {
                    tempArr.push({
                      show_sc: false,
                      is_scratched: uo.is_scratched,
                      scratched_on: uo.scratched_on ? uo.scratched_on : uo.created_at,
                      logo: uo.reward_logo,
                      value: uo.value,
                      is_available_now: uo.is_available_now,
                      title: uo.offer_title,
                      desc: uo.description,
                      earned_for: uo.message,
                      ref: uo.ref,
                      reward_type: uo.reward_type,
                      reward_logo: uo.reward_logo
                    });
                }
              });

              self.allUserOffers = [...self.allUserOffers,...tempArr];
              $state.loaded();
            } else {
              $state.complete();
              self.is_shimmer = self.allUserOffers.length>10;
            }
          } else {
            self.is_shimmer = false;
            console.log("Error fetching the user offers");
          }
        })
      }
    },
    created() {
      this.$store.state.showHeader = false;
      this.$store.state.showWallet = false;
      this.$store.state.showHistory = false;
      this.$store.state.headTitle = "Rewards";
    },
  }
</script>
<style>
  .sc-wrapper {
    display: grid;
    grid-template-columns: repeat(2, minmax(170px, 1fr));
  }

  @media screen and (min-width: 320px) {
    .sc-wrapper {
      grid-template-columns: repeat(2, minmax(145px, 1fr));
    }
    .point-card-padding {
        padding: 3rem 0;
    }
  }

  @media screen and (min-width: 768px) {
    .sc-wrapper {
      grid-template-columns: repeat(3, minmax(170px, 1fr));
    }
    .point-card-padding {
      padding: 2rem 0;
    }

  }

  @media screen and (min-width: 1024px) {
    .sc-wrapper {
      grid-template-columns: repeat(6, minmax(170px, 1fr));
    }
    .point-card-padding {
      padding: 2rem 0;
    }

  }
  .sc-wrap {
  }
  .scratched-reward-icon {
    width: 70px;
  }
  .card-content {
    width: 200px;
    height: 200px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }

  .sc-all {
    height:85%;
    min-height: 168px;
    max-height: 168px
  }



</style>



// WEBPACK FOOTER //
// src/screens/rewards.vue